import React, { useEffect, useState } from 'react';
import { Settings } from '@mui/icons-material';
import { useNotifyAlert } from 'context/NotifyAlert';
import SelectSearch from 'newComponents/SelectSearch';
import { getTenantId, getWhatsappUserInfo } from 'util/isAdmin';
import { useToggleIA, useUpdateSettings } from '../hooks/settings';
import { GreenSwitch } from '../../Departments/WhasappUsers/styles';
import { Input } from 'newComponents/InputSearch/styles';
import { SaveButton } from '../../Departments/NewDepartmentModal/styles';
import { auth as authApi } from 'api/credentials';
import DialogAlert from 'newComponents/DialogComponent/DialogAlert';

export const ToggleIA = ( { statusIA, isLoadingStatus, refetch, users, settings, isLoadingSettings, shouldFinalizeChat, getChatsWithoutResponse, shouldSendMessageAfterCall } ) => {
	const tenantId = getTenantId();
	const isAdmin = getWhatsappUserInfo()?.profile_type_id === 1;

	const [ selectedIAUser, setSelectedIAUser ] = useState( null );
	const [ selectedIASenha, setSelectedIASenha ] = useState( '' );
	const { updateSettings } = useUpdateSettings();
	const [ loadingSaveSettings, setLoadingSaveSettings ] = useState( false );
	const { toggleIAAsync, isLoading: isToggling } = useToggleIA();
	const { setShowNotify } = useNotifyAlert();
	const [ showAlert, setShowAlert ] = useState( false );

	useEffect( () => {
		if ( settings ) {
			setSelectedIAUser( {
				acordoFechadoId : settings.ia_user_id,
				email           : settings.ia_email
			} );
			setSelectedIASenha( settings.ia_user_password );
		}
	}, [ settings ] );

	const handleToggleIA = async (data) => {
		try {
			await toggleIAAsync( data );
			setShowNotify( { status: 'success', text: 'Status da IA atualizado com sucesso!' } );
			// Refetch to get updated status
			refetch();
		} catch ( error ) {
			setShowNotify( { status: 'error', text: 'Erro ao atualizar status da IA.' } );
		}
	};

	const handleSaveSettings = async () => {
		setLoadingSaveSettings( 'Testando login...' );
		const settingsData = {
			session_id       : `session-${tenantId}`,
			ia_user_id       : selectedIAUser.acordoFechadoId,
			ia_email         : selectedIAUser.email,
			ia_user_password : selectedIASenha
		};

		await authApi.signInWithEmailAndPassword( { username: selectedIAUser.email, password: selectedIASenha } )
			.then( async ( response ) => {
				if ( response.data.message === 'Logado com sucesso' ) {
					setLoadingSaveSettings( 'Salvando configurações...' );
					try {
						await updateSettings( settingsData );
						setShowNotify( { status: 'success', text: 'Configurações salvas com sucesso!' } );
					} catch ( error ) {
						setShowNotify( { status: 'error', text: 'Erro ao salvar configurações.' } );
					}
				}
			} ).catch( () => {
				setShowNotify( { status: 'error', text: 'Erro ao testar login.' } );
			} )
			.finally( () => setLoadingSaveSettings( false ) );
	};

	const disabledActiveIA = tenantId !== 3 && !isAdmin;

	return (
		<>
		<div style={{ border: '1px solid #e0e0e0', borderRadius: '12px', padding: '22px' }} className='bg-white d-flex flex-column justify-content-between'>
			<div className='d-flex align-items-center' style={{ gap: '10px' }}>
				<Settings />
				<h3 className='mb-0'>Ativação da IA</h3>
			</div>
			{isLoadingStatus ? <p>Carregando...</p> : (
				<div>
					<div className='d-flex align-items-center justify-content-between' style={{ marginTop: '26px' }}>
						<div className='d-flex flex-column'>
							<p className='mb-0' style={{ fontSize: '16px', color: '#0A0A0A', fontWeight: '600' }}>Ativar IA de Atendimento</p>
							<p className='mb-0' style={{ fontSize: '14px', color: '#666666' }}>A IA pode responder automaticamente a mensagens iniciais ou auxiliar em fluxos de negociação</p>
						</div>
						<GreenSwitch
							checked={statusIA || false}
							onChange={disabledActiveIA ? () => setShowAlert( true ) : async () => {
								await handleToggleIA({
									session_id: `session-${tenantId}`,
									shouldFinalizeChat: shouldFinalizeChat,
									getChatsWithoutResponse: getChatsWithoutResponse,
									statusIA: !statusIA,
									shouldSendMessageAfterCall: shouldSendMessageAfterCall
								})
							}}
							disabled={isLoadingStatus || isToggling}
						/>
					</div>
					{statusIA && (<>
						<div className='d-flex align-items-center justify-content-between'>
							<p className='mb-0' style={{ fontSize: '14px', color: '#666666' }}>A IA assume o atendimento se ficar um dia sem resposta do negociador</p>
							<GreenSwitch
								checked={getChatsWithoutResponse || false}
								onChange={async () => {
									await handleToggleIA({
										session_id: `session-${tenantId}`,
										shouldFinalizeChat: shouldFinalizeChat,
										getChatsWithoutResponse: !getChatsWithoutResponse,
										statusIA: statusIA,
										shouldSendMessageAfterCall: shouldSendMessageAfterCall
									})
								}}
								disabled={isLoadingStatus || isToggling}
							/>
						</div>
						<div className='d-flex align-items-center justify-content-between'>
							<p className='mb-0' style={{ fontSize: '14px', color: '#666666' }}>A IA finaliza o atendimento se ficar um dia sem resposta da parte adversa</p>
							<GreenSwitch
								checked={shouldFinalizeChat || false}
								onChange={async () => {
									await handleToggleIA({
										session_id: `session-${tenantId}`,
										shouldFinalizeChat: !shouldFinalizeChat,
										getChatsWithoutResponse: getChatsWithoutResponse,
										statusIA: statusIA,
										shouldSendMessageAfterCall: shouldSendMessageAfterCall
									})
								}}
								disabled={isLoadingStatus || isToggling}
							/>
						</div>
				</>)}
					{statusIA && (
						<div className='d-flex flex-column' style={{ gap: '20px', marginTop: '26px' }}>
							<div className='d-flex flex-wrap w-100' style={{ gap: '20px' }}>
								<div className='d-flex align-items-end' style={{ gap: '10px',  }}>
									<h3 className='mb-0'>Usuário da IA:</h3>
									<div className='d-flex align-items-center' style={{ gap: '10px', minWidth: '200px' }}>
										{isLoadingSettings ? <p>Carregando...</p> : (
											<SelectSearch
												fullWidth={true}
												options={users.map( user => ( { label: user.email, value: user.acordoFechadoId } ) )}
												value={selectedIAUser?.acordoFechadoId || ''}
												setSelectedState={( e ) => setSelectedIAUser( users.find( user => user.acordoFechadoId === e ) )}
											/>
										)}
									</div>
								</div>
								<div className='d-flex align-items-end' style={{ gap: '10px',  }}>
									<h3 className='mb-0'>Senha do usuário da IA:</h3>
									<div className='d-flex align-items-end' style={{ gap: '10px' }}>
										{isLoadingSettings ? <p>Carregando...</p> : (
											<Input
												type='password'
												fullWidth={true}
												value={selectedIASenha}
												onChange={( e ) => setSelectedIASenha( e.target.value )}
											/>
										)}
									</div>
								</div>
							</div>
							<SaveButton
								onClick={handleSaveSettings}
								disabled={loadingSaveSettings}
							>
								{loadingSaveSettings ? loadingSaveSettings : 'Salvar'}
							</SaveButton>
						</div>
					)}
				</div>
			)}
			{showAlert && (
				<DialogAlert
					isOpen={showAlert}
					title='Atenção'
					subTitle={`Entre em contato com o Acordo Fechado para ${statusIA ? 'DESATIVAR' : 'ATIVAR'} a IA de Atendimento`}
					closeFunction={() => setShowAlert( false )}
				>
				</DialogAlert>
			)}
		</div>
		<div style={{ border: '1px solid #e0e0e0', borderRadius: '12px', padding: '22px' }} className='bg-white d-flex flex-column justify-content-between'>
		<div className='d-flex align-items-center' style={{ gap: '10px' }}>
				<Settings />
				<h3 className='mb-0'>Configurações de chamada de atenção</h3>
			</div>
			<div className='d-flex align-items-center justify-content-between'>
							<p className='mb-0' style={{ fontSize: '14px', color: '#666666' }}>Deve enviar mensagem após chamar atenção.</p>
							<GreenSwitch
								checked={shouldSendMessageAfterCall || false}
								onChange={async () => {
									await handleToggleIA({
										session_id: `session-${tenantId}`,
										shouldFinalizeChat: shouldFinalizeChat,
										getChatsWithoutResponse: getChatsWithoutResponse,
										shouldSendMessageAfterCall: !shouldSendMessageAfterCall,
										statusIA: statusIA
									})
								}}
								disabled={isLoadingStatus || isToggling}
								/>
		</div>
		</div>
		</>
	);
};

export default ToggleIA;
